import { useLazyQuery } from "@apollo/client/react";
import { useMemo, useState } from "react";
import { GET_LIQUIDACION_FINAL } from "../../../data/graphQL/queries/LiquidacionFinal/getLiquidacionFinal";
import toast from "react-hot-toast";

export const useGetRows = (filters, setIsRefetchRequired) => {
    const [busquedaCompletada, setBusquedaCompletada] = useState(false);

    const [getLiquidacionFinal, { data, loading }] = useLazyQuery(GET_LIQUIDACION_FINAL, {
        fetchPolicy: 'no-cache',
    });

    const handleSearch = () => {
        if (!filters.idDelegacion) {
            toast.error("Debe seleccionar una delegación para realizar la búsqueda");
            return;
        }
        getLiquidacionFinal({
            variables: {
                input: {
                    mes: filters.mes,
                    anio: filters.anio,
                    idTipoProfesional: filters.idTipoProfesional,
                    idDelegacion: filters.idDelegacion,
                    idEstado: filters.idEstado,
                    idsProfesionales: filters.idsProfesionales ?? []
                }
            }
        }).then(() => {
            setBusquedaCompletada(true);
            setIsRefetchRequired(false);
        });
    };

    const liquidacionesPorProfesional = useMemo(() => {
        const liquidaciones = data?.liquidacionFinal?.valorEsperado ?? [];

        if (liquidaciones.length === 0) return [];


        return Object.values(
            liquidaciones.reduce((acc, liquidacion) => {
                const { idProfesional, idLiquidacionProfesional } = liquidacion;

                if (!acc[idProfesional]) {
                    acc[idProfesional] = {
                        idProfesional,
                        idLiquidacionProfesional,
                        profesionalData: {
                            id: idProfesional,
                            profesional: liquidacion.profesional,
                            sap: liquidacion.codigoSAPProfesional,
                            tieneHonorarioFidelizado: false,
                            observacionRechazo: liquidacion.observacionRechazo
                        },
                        liquidaciones: [],
                    };
                }

                if (liquidacion.tieneHonorarioFidelizado) {
                    acc[idProfesional].profesionalData.tieneHonorarioFidelizado = true;
                }

                acc[idProfesional].liquidaciones.push(liquidacion);

                return acc;
            }, {})
        );
    }, [data]);

    return {
        handleSearch,
        liquidacionesPorProfesional,
        loading,
        busquedaCompletada
    };
};